module.exports = __webpack_public_path__ + "media/images/lb/327-8d554302f7621dffe6f8d8b4f44a13a0.svg";